import { RevokeExpirePermissions } from '../store/schema/OmeMessageState';
import OmeMessageState from '../store/schema/OmeMessageState';

export default function hasRevokePermission(omeMessageState: OmeMessageState): boolean {
    return omeMessageState && omeMessageState.permissions == RevokeExpirePermissions.Revocable;
}
